import React, { useState, useEffect } from "react";

function Number() {
  const [countdown1, setCountdown1] = useState(0);
  const [countdown2, setCountdown2] = useState(0);
  const [countdown3, setCountdown3] = useState(0);
  const [countdown4, setCountdown4] = useState(0);
  const maxValue1 = 183; // Set your maximum value here
  const maxValue2 = 192; // Set your maximum value here
  const maxValue3 = 246; // Set your maximum value here
  const maxValue4 = 12; // Set your maximum value here
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    // Function to increment the countdown value
    const incrementCountdown1 = () => {
      if (countdown1 < maxValue1) {
        setCountdown1(countdown1 + 6);
      }
    };
    const incrementCountdown2 = () => {
      if (countdown2 < maxValue2) {
        setCountdown2(countdown2 + 6);
      }
    };
    const incrementCountdown3 = () => {
      if (countdown3 < maxValue3) {
        setCountdown3(countdown3 + 6);
      }
    };
    const incrementCountdown4 = () => {
      if (countdown4 < maxValue4) {
        setCountdown4(countdown4 + 1);
      }
    };

    // Start the countdown when the user hovers
    if (hovered) {
      const interval1 = setInterval(incrementCountdown1, 50); // Increment every 1 second
      const interval2 = setInterval(incrementCountdown2, 50); // Increment every 1 second
      const interval3 = setInterval(incrementCountdown3, 50); // Increment every 1 second
      const interval4 = setInterval(incrementCountdown4, 50); // Increment every 1 second

      // Clean up the interval when the component unmounts or when the user stops hovering
      return () => {
        clearInterval(interval1);
        clearInterval(interval2);
        clearInterval(interval3);
        clearInterval(interval4);

        // Reset the countdown when not hovering
      };
    }
  }, [countdown1, countdown2, countdown3, countdown4, hovered, maxValue1, maxValue2, maxValue3, maxValue4]);

  const links = [
    { name: "Open roles", href: "#" },
    { name: "Internship program", href: "https://www.quizaro.co.in/" },
    { name: "Our values", href: "#vision" },
    { name: "Meet our leadership", href: "#team" },
  ];
  const stats = [
    { name: "Our Connections", value: countdown1 },
    { name: "Full-time colleagues", value: countdown2 },
    { name: "Hours per week", value: countdown3 },
    { name: "Paid time off", value: countdown4 },
  ];

  return (
    <div onMouseEnter={() => setHovered(true)} className="relative isolate overflow-hidden bg-gray-900 py-24 sm:py-32" id="statics">
      <img
        src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&crop=focalpoint&fp-y=.8&w=2830&h=1500&q=80&blend=111827&sat=-100&exp=15&blend-mode=multiply"
        alt=""
        className="absolute inset-0 -z-10 h-full w-full object-cover object-right md:object-center"
      />
      <div className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl" aria-hidden="true">
        <div
          className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
          style={{
            clipPath:
              "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
          }}
        />
      </div>
      <div
        className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
        aria-hidden="true"
      >
        <div
          className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
          style={{
            clipPath:
              "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
          }}
        />
      </div>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-4xl font-bold capitalize tracking-tight text-white sm:text-6xl">Work with us</h2>
          <p className="mt-6 text-lg leading-8 text-gray-300">
            Join our passionate team dedicated to reshaping industries, driving innovation, and delivering outstanding results. Discover a rewarding career
            journey with us.
          </p>
        </div>
        <div className="mx-auto mt-10 max-w-2xl lg:mx-0 lg:max-w-none">
          <div className="grid grid-cols-1 gap-x-8 gap-y-6 text-base font-semibold leading-7 text-white sm:grid-cols-2 md:flex lg:gap-x-10">
            {links.map((link) => (
              <a key={link.name} href={link.href}>
                {link.name} <span aria-hidden="true">&rarr;</span>
              </a>
            ))}
          </div>
          <dl className="mt-16 grid grid-cols-1 gap-8 sm:mt-20 sm:grid-cols-2 lg:grid-cols-4">
            {stats.map((stat) => (
              <div key={stat.name} className="flex flex-col-reverse">
                <dt className="text-base leading-7 text-gray-300">{stat.name}</dt>
                <dd className="text-2xl font-bold leading-9 tracking-tight text-white"> {stat.value}+ </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
export default Number;
